import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AutomationTextsAPI from '../../api/automationTexts';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAutomationTexts(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAutomationTextById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getAutomationTexts({ commit }) {
    commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isFetching: true });
    try {
      const response = await AutomationTextsAPI.get();
      commit(types.SET_AUTOMATION_TEXTS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createAutomationText({ commit }, obj) {
    commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isCreating: true });
    try {
      const response = await AutomationTextsAPI.create(obj);
      commit(types.ADD_AUTOMATION_TEXT, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateAutomationText(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isUpdating: true });
    try {
      const response = await AutomationTextsAPI.update(id, updateObj);
      commit(types.EDIT_AUTOMATION_TEXT, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteAutomationText({ commit }, id) {
    commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isDeleting: true });
    try {
      await AutomationTextsAPI.delete(id);
      commit(types.DELETE_AUTOMATION_TEXT, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AUTOMATION_TEXT_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_AUTOMATION_TEXT_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_AUTOMATION_TEXTS]: MutationHelpers.set,
  [types.ADD_AUTOMATION_TEXT]: MutationHelpers.create,
  [types.EDIT_AUTOMATION_TEXT]: MutationHelpers.update,
  [types.DELETE_AUTOMATION_TEXT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
